/**
 * Penyimpan access token — sumber kebenaran tunggal untuk token aktif.
 * Disimpan di localStorage agar sesi bertahan saat refresh halaman
 * (client 'web' tidak punya refresh token, jadi token access langsung dipakai).
 *
 * Modul ini sengaja TANPA dependency lain supaya bebas dari circular import
 * (dipakai oleh http-client maupun auth store).
 */
const STORAGE_KEY = 'pos.accessToken'

let token: string | null = readInitial()

function readInitial(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export const authToken = {
  get(): string | null {
    return token
  },
  set(value: string): void {
    token = value
    try {
      localStorage.setItem(STORAGE_KEY, value)
    } catch {
      /* localStorage tidak tersedia — token tetap ada di memori */
    }
  },
  clear(): void {
    token = null
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch {
      /* abaikan */
    }
  },
}

/** Nama event yang di-dispatch saat server menolak token (401). */
export const UNAUTHORIZED_EVENT = 'auth:unauthorized'
